import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/e502ca8bb9bf21f6a6ac12f4ba9bc73f.jpg)',
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center w-full py-32">
        
        <h1 className="text-5xl lg:text-7xl font-extrabold text-white mb-6 leading-tight">
          YOUR COMPLETE<br />
          <span className="text-gold">ELECTRICAL SOLUTION</span>
        </h1>
        
        <p className="text-xl lg:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto font-light">
          Fresh approach to electrical services across Western Australia.<br />
          Residential • Commercial • Industrial
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="/contact"
            className="bg-gold text-navy px-8 py-4 rounded-lg font-bold text-base tracking-wider hover:bg-gold-light transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            GET A QUOTE
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <a
            href="tel:+61400000000"
            className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-base tracking-wider hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-fill text-xl"></i>
            0400 000 000
          </a>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-fill text-gold text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-sm font-semibold">Licensed & Insured</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-gold text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-sm font-semibold">Australian Standards</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-fill text-gold text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-sm font-semibold">Prompt Service</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
